export default __webpack_public_path__ + "ui/assets/img/profile-16-info.svg";